import React from 'react';
import PropTypes from 'prop-types';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import { ClassicEditor } from '@ckeditor/ckeditor5-editor-classic';
// import { Bold, Italic } from '@ckeditor/ckeditor5-basic-styles';
// import { Undo } from '@ckeditor/ckeditor5-undo';
// import { Indent } from '@ckeditor/ckeditor5-indent';
// import { Link } from '@ckeditor/ckeditor5-link';
// import { RemoveFormat } from '@ckeditor/ckeditor5-remove-format';
import LabelledInputLayout from './LabelledInputLayout';

const TYPE_CHOICES = [
  'text',
  'textarea',
];

/*
    "@ckeditor/ckeditor5-basic-styles": "^39.0.2",
    "@ckeditor/ckeditor5-editor-classic": "^39.0.2",
    "@ckeditor/ckeditor5-indent": "^39.0.2",
    "@ckeditor/ckeditor5-link": "^39.0.2",
    "@ckeditor/ckeditor5-react": "^6.1.0",
    "@ckeditor/ckeditor5-remove-format": "^39.0.2",
    "@ckeditor/ckeditor5-undo": "^39.0.2",
 */

const TextInputField = ({
  id,
  label = '',
  isRequired = false,
  className = '',
  maxLength = 200,
  errorMsg = [],
  touched = false,
  characterCounter = false,
  type = 'text',
  onChange = () => {},
  onBlur = () => {},
  value = '',
}) => {
  // eslint-disable-next-line no-undef
  const customEditor = ClassicEditor;
  return (
    <LabelledInputLayout
      id={id}
      label={label}
      isRequired={isRequired}
      className={className}
      errorMsg={errorMsg}
      touched={touched}
    >
      {type === 'textarea' && (
        <div id={id}>
          <CKEditor
            editor={customEditor}
            config={{
              // plugins: [Bold, Italic, Indent, Link, Undo, RemoveFormat],
              removePlugins: ['CKFinder', 'Image', 'EasyImage', 'ImageCaption', 'ImageStyle', 'ImageToolbar', 'ImageUpload', 'MediaEmbed'],
              toolbar: [
                'bold', 'italic',
                '|', 'numberedList', 'bulletedList',
                '|', 'outdent', 'indent',
                '|', 'link', 'unlink',
                '|', 'undo', 'redo',
                '|', 'removeFormat',
              ],
              wordcount: {
                maxCharCount: maxLength,
              },
            }}
            data={value}
            onReady={(editor) => {
              editor.editing.view.change((writer) => {
                writer.setStyle(
                  'height',
                  '240px',
                  editor.editing.view.document.getRoot(),
                );
              });
            }}
            onChange={(event, editor) => {
              onChange({
                target: {
                  name: id,
                  value: editor.getData(),
                  type: 'textarea',
                  checked: null,
                },
              });
            }}
            onBlur={(event, editor) => {
              onBlur({
                target: {
                  name: id,
                  value: editor.getData(),
                  type: 'textarea',
                  checked: null,
                },
              });
            }}
          />
        </div>
      )}
      {(type === 'text' || !TYPE_CHOICES.includes(type)) && (
        <input
          type="text"
          name={id}
          autoComplete="off"
          maxLength={maxLength}
          required={isRequired}
          id={id}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          style={{ marginBottom: '0.5rem' }}
        />
      )}
      {characterCounter && (
        <div className="help-text">
          {value.length}/{maxLength} max characters
        </div>
      )}
    </LabelledInputLayout>
  );
};

TextInputField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  className: PropTypes.string,
  maxLength: PropTypes.number,
  errorMsg: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  touched: PropTypes.bool,
  type: PropTypes.string,
  characterCounter: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
};

export default TextInputField;
